import React from 'react';
import {
  IonIcon,
  IonButton,
} from '@ionic/react';
import {
  calendarOutline,
  locationOutline,
  createOutline,
  timeOutline,
} from 'ionicons/icons';
import { Inspection } from '../../../types/model/inspection';
import { useEffect } from 'react';
import { getInspectionStatusColor, getStatusText, getTimeSensitivityColor, getTimeSensitivityText } from '../common/helpers';

interface InspectionAccordionRowProps {
  inspection: Inspection;
  index: number;
  isDetailsExpanded: boolean;
  onInspectionClick: (inspection: Inspection) => void;
  onToggleDetails: (inspectionId: number) => void;
}

const InspectionAccordionRow: React.FC<InspectionAccordionRowProps> = ({
  inspection,
  index,
//   isDetailsExpanded,
  onInspectionClick,
//   onToggleDetails,
}) => {
    const [rowData, setRowData] = React.useState<Inspection>(inspection);

    useEffect(() => {
        setRowData(inspection);
    }, [inspection]);

  const formatDate = (dateString?: string) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div key={rowData.inspectionResultId}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 100px',
        gap: '1rem',
        padding: '1rem',
        borderBottom: '1px solid var(--ion-color-step-250, var(--ion-color-light-shade))',
        alignItems: 'center',
        background: index % 2 === 0
          ? 'var(--ion-color-step-100, var(--ion-color-light-tint))'
          : 'var(--ion-color-step-50, #ffffff)',
        color: 'var(--ion-text-color, inherit)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <IonIcon icon={locationOutline} size="small" />
          {rowData.siteName}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '6rem', color: rowData.scheduledDate ? 'var(--ion-color-primary)' : 'var(--ion-color-medium)' }}>
          <IonIcon icon={calendarOutline} size="small" />
          {rowData.scheduledDate ? formatDate(rowData.scheduledDate) : '—'}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '6rem' }}>
          <IonIcon icon={calendarOutline} size="small" />
          {formatDate(rowData.inspectedOn)}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '6rem' }}>
          <span style={{
            fontSize: '0.8rem',
            fontWeight: '500',
            color: getInspectionStatusColor(rowData.status),
          }}>
            {getStatusText(rowData.status)}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
          <IonIcon
            icon={timeOutline}
            style={{ fontSize: '1rem', color: getTimeSensitivityColor(rowData.timeSensitivity), flexShrink: 0 }}
          />
          <span style={{ fontSize: '0.8rem', color: getTimeSensitivityColor(rowData.timeSensitivity) }}>
            {getTimeSensitivityText(rowData.timeSensitivity)}
          </span>
        </div>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.25rem', 
          justifyContent: 'center' 
        }}>
          <IonButton 
            fill="clear" 
            size="small"
            onClick={() => onInspectionClick(rowData)}
            title="Open Inspection"
          >
            <IonIcon icon={createOutline} />
          </IonButton>
        </div>
      </div>
     
    </div>
  );
};

export default InspectionAccordionRow;